<template>
  <div>
    <div class="flex items-center justify-between mt-4 table-header-row">
      <div class="row-1">
        <slot name="header" ></slot>
      </div>
      <span class="row-2 flex items-center justify-center">{{ from }}</span>
      <div class="row-3">
        <img 
          src="@/assets/orderTest/order-page/order-test-panel/menu-switch-dialog/arrow_right_white_20px.svg" 
        >
      </div>
      <span class="row-4 flex items-center justify-center">{{ to }}</span>
    </div>
    <div 
      v-for="row in data" 
      :key="row.id"
      class="flex items-center justify-start table-data-row"
    >
      <div class="pl-2.5 row-1">{{ row.name }}</div>
      <div class="from-price-text row-2 flex justify-center">
        {{ row.fromPrice }}
      </div>
      <div class="row-3">
        <img 
          src="@/assets/orderTest/order-page/order-test-panel/menu-switch-dialog/arrow_right_black_20px.svg" 
        >
      </div>
      <div class="to-price-text row-4 flex justify-center">
        {{ row.toPrice }}
      </div>     
    </div> 
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    from: {
      type: String,
      default: ""
    },
    to: {
      type: String,
      default: ""
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(["currency"])
  }
}
</script>

<style scoped>
.table-header-row {
  height: 30px;
  background: #20A8C3;
  border: 1px solid #20A8C3;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4004px;
  color: #FFFFFF;
}

.row-1 {
  width: 35%;
}

.row-2 {
  width: 30%;
}

.row-3 {
  width: 5%;
}

.row-4 {
  width: 30%;
}

.table-data-row {
  min-height: 30px;
  background: #F8FAFB;
  font-weight: 500;
  font-size: 13px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
}

.from-price-text {
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.4004px;
  text-decoration-line: line-through;
  color: #767676;
}

.to-price-text {
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.4004px;
}
</style>